const snakedata = [
    
    {
    
      id:"1",
      photo:'https://i.ibb.co/LJkFm7h/93612281-2512063869057560-3534203909272764416-n.jpg',
      name: 'අළු රදනකයා (නිර්විෂ)',
      bodyColor: '12',
      style: '2',
      poison:'4',
    },
    {
    
      id:"2",
      photo:'https://i.ibb.co/JjHPSKL/L-aulicus5.jpg', //not enter
      name: 'අළු රදනකයා (නිර්විෂ)',
      bodyColor: '11',
      style: '3',
      poison:'4',
    },
    {
        id:"3",
        photo:'https://i.ibb.co/G2xfGqF/92163333-2505066009757346-4051795103923044352-n.jpg',
        name: 'පුල්ලි දත්කැටියා (නිර්විෂ)',
        bodyColor: '11',
        style: '4',
        poison:'4',
      },
      {
        id:"4",
        photo:'https://i.ibb.co/5K7ckPp/277097643-974853306500885-7168164217414062499-n.jpg',
        name: 'දියවර්ණයා (නිර්විෂ)',
        bodyColor: '11',
        style: '3',
        poison:'4',
      },
      {
        id:"5",
        photo:'https://i.ibb.co/gm4GtNs/277783079-144037094783466-1288613877288412507-n.jpg',
        name: 'පළා පොළගා (මද විෂ)',
        bodyColor: '13',
        style: '1',
        poison:'2',
      },
      {
        id:"6",
        photo:'https://i.ibb.co/9Gfwxy0/277742184-3043606669236608-1996179624972374316-n.jpg',
        name: 'පිඹුරා (නිර්විෂ)',
        bodyColor: '11',
        style: '5',
        poison:'4',
      },
      {
        id:"7",
        photo:'https://i.ibb.co/M1hxnjX/274009636-132449445942231-7142250091059082855-n.jpg',
        name: 'මල්සරා/පොල්මල් කරවලා (සුළු විෂ)',
        bodyColor: '12',
        style: '6',
        poison:'3',
      },
      {
        id:"8",
        photo:'https://i.ibb.co/HhNbfVx/120224756-2650746081856004-8514183424616115588-n.jpg',
        name: 'මුදු කරවැලා (උග්‍ර විෂ)',
        bodyColor: '12',
        style: '7',
        poison:'1',
      },
      {
        id:"9",
        photo:'https://i.ibb.co/3RkWMmZ/272950039-128472769673232-103300385119282149-n.jpg',
        name: 'දියබරියා (නිර්විෂ)',
        bodyColor: '11',
        style: '1',
        poison:'4',
      },
      {
        id:"10",
        photo:'https://i.ibb.co/NL8gGpP/327917409-1381489535961615-1222442974555124294-n.jpg',
        name: 'දළව මැඩිල්ලා (නිර්විෂ)',
        bodyColor: '11',
        style: '4',
        poison:'4',
      },
      {
        id:"11",
        photo:'https://i.ibb.co/SJY991Z/22219861-1316496478472447-7029110988306806258-o.jpg',
        name: 'කහ හිරිදණ්ඩා (නිර්විෂ)',
        bodyColor: '14',
        style: '3',
        poison:'4',
      },
      {
        id:"12",
        photo:'https://i.ibb.co/v4bL1Ct/272216346-126484776538698-930412940866950574-n.jpg',
        name: 'ඇහැටුල්ලා (සුළු විෂ)',
        bodyColor: '13',
        style: '3',
        poison:'3',
      },
      {
        id:"13",
        photo:'https://i.ibb.co/y6b5tbM/82852286-2439106446353303-2529307507629752320-n.jpg',
        name: 'කුවියර්ගේ වල්ගා ඇබයා (නිර්විෂ)',
        bodyColor: '12',
        style: '3',
        poison:'4',
      },
      {
        id:"14",
        photo:'https://i.ibb.co/6X95wY7/137238955-2730771707186774-5254133665104838708-n.jpg',
        name: 'ලේ මැඩිල්ලා (නිර්විෂ)',
        bodyColor: '15',
        style: '4',
        poison:'4',
      },
      {
        id:"15",
        photo:'https://i.ibb.co/MDcq7my/321609242-3226292327633237-8397320553981112195-n.jpg',
        name: 'තපෝ තුඩුල්ලා (නිර්විෂ)',
        bodyColor: '14',
        style: '3',
        poison:'4',
      },
      {
        id:"16",
        photo:'https://i.ibb.co/ZLBjtsS/80695087-2409105339353414-2144483690653155328-n.jpg',
        name: 'මූකලන් හාල්දණ්ඩා (නිර්විෂ)',
        bodyColor: '14',
        style: '3',
        poison:'4',
      },
      {
        id:"17",
        photo:'https://i.ibb.co/hYJN6yP/319395582-1138397026813178-4074803885114611752-n.jpg',
        name: 'කහ මාපිලා (සුළු විෂ)',
        bodyColor: '11',
        style: '1',
        poison:'3',
      },
      {
        id:"18",
        photo:'https://i.ibb.co/gd8Qbzm/76643698-2386398658290749-6934395175233912832-n.jpg',
        name: 'පොළොන් තෙලිස්සා / කුණකටුවා (උග්‍ර විෂ)',
        bodyColor: '11',
        style: '4',
        poison:'1',
      },
      {
        id:"19",
        photo:'https://i.ibb.co/NjZQbZj/316824042-1857384317937513-9084284495052399112-n.jpg',
        name: 'පොළොන් තෙලිස්සා / කුණකටුවා (උග්‍ර විෂ)',
        bodyColor: '16',
        style: '4',
        poison:'1',
      },
      {
        id:"20",
        photo:'https://i.ibb.co/X3MQNNZ/111874563-2591451111118835-8994278828910484305-n.jpg',
        name: 'අහරකුක්කා (නිර්විෂ)',
        bodyColor: '11',
        style: '1',
        poison:'4',
      },
      {
        id:"21",
        photo:'https://i.ibb.co/VwsdWDG/108060866-2584928385104441-5866046967547235165-n.jpg',
        name: 'කටකළුවා (නිර්විෂ)',
        bodyColor: '11',
        style: '1',
        poison:'4',
      },
      {
        id:"22",
        photo:'https://i.ibb.co/pQk4dQd/106739363-2576100985987181-9047823482532157031-n.jpg',
        name: 'අනංගුලි සර්ප හීරළුවා (නිර්විෂ)',
        bodyColor: '12',
        style: '3',  //not enter
        poison:'4',
      },
      {
        id:"23",
        photo:'https://i.ibb.co/ZW5016V/97907296-2537871516476795-5132739893021114368-n.jpg',
        name: 'නිදි මාපිලා (සුළු විෂ)',
        bodyColor: '11',
        style: '4',
        poison:'3',
      },
      {
        id:"24",
        photo:'https://i.ibb.co/F5F9dhC/124573578-2687257574871521-25922372876770530-n.jpg',
        name: 'දෙපත් නයා (නිර්විෂ)',
        bodyColor: '17',
        style: '2',
        poison:'4',
      },
      {
        id:"25",
        photo:'https://i.ibb.co/t8px6B1/191739965-2836034493327161-1533221427413535185-n.jpg',
        name: 'දියබරියා (නිර්විෂ)',
        bodyColor: '11',
        style: '1',
        poison:'4',
      },
      {
        id:"26",
        photo:'https://i.ibb.co/g4z4nV9/119059985-2635424646721481-568254278851441204-n.jpg',
        name: 'රෑන් මාපිලා/ගැරඬි මාපිලා (සුළු විෂ)',
        bodyColor: '11',
        style: '1',
        poison:'3',
      },
      {
        id:"27",
        photo:'https://i.ibb.co/YDZVfqg/342599790-1660426437728921-5832559337408863157-n.jpg',
        name: 'අරණි දත් කැටියා (නිර්විෂ)',
        bodyColor: '16',
        style: '8',
        poison:'4',
      },
      {
        id:"28",
        photo:'https://i.ibb.co/MM9jRy0/342179823-191414507041598-4012074441711686281-n.jpg',
        name: ' දැති ගෝමරයා (නිර්විෂ)',
        bodyColor: '11',
        style: '3',
        poison:'4',
      },
      {
        id:"29",
        photo:'https://i.ibb.co/gd8Qbzm/76643698-2386398658290749-6934395175233912832-n.jpg',
        name: 'පොළොන් තෙලිස්සා / කුණකටුවා (උග්‍ර විෂ)',
        bodyColor: '11', //not enter
        style: '4',
        poison:'1',
      },
      {
        id:"30",
        photo:'https://i.ibb.co/HXCqDm9/H-hypnale5.jpg',
        name: 'පොළොන් තෙලිස්සා / කුණකටුවා (උග්‍ර විෂ)',
        bodyColor: '12',
        style: '4',
        poison:'1',
      },
      {
        id:"31",
        photo:'https://i.ibb.co/GRGKZN4/13522705-591730797670017-7100245682734181521-o.jpg',
        name: 'මල් රදනකයා/කුණුමී කරවලා (නිර්විෂ)',
        bodyColor: '11',
        style: '8',
        poison:'4',
      },
      {
        id:"32",
        photo:'https://i.ibb.co/2Pzhxy7/341898604-273866961632593-3863607626108720777-n.jpg',
        name: 'පදුරු හාල්දන්ඩා (නිර්විෂ)',
        bodyColor: '11',
        style: '1',
        poison:'4',
      },
      {
        id:"33",
        photo:'https://i.ibb.co/HD94k4Z/341563307-1258251118138996-1090822874111798917-n.jpg',
        name: 'උල් තුඩුල්ලා (නිර්විෂ)',
        bodyColor: '11',
        style: '3',
        poison:'4',
      },
      {
        id:"34",
        photo:'https://i.ibb.co/4T2RQmt/337887968-195893176548436-8964611309437156824-n.jpg',
        name: ' වයිරි දත්කැටියා (නිර්විෂ)',
        bodyColor: '11',
        style: '1',
        poison:'4',
      },
      {
        id:"35",
        photo:'https://i.ibb.co/LJkFm7h/93612281-2512063869057560-3534203909272764416-n.jpg',
        name: 'අළු රදනකයා (නිර්විෂ)',
        bodyColor: '11', //not enter
        style: '2',
        poison:'4',
      },
      {
        id:"36",
        photo:'https://i.ibb.co/2dKt6L0/316531886-1857378087938136-3417614509194579440-n.jpg',
        name: 'වැලි පිඹුරා /කොට පිඹුරා (නිර්විෂ)',
        bodyColor: '12',
        style: '4',
        poison:'4',
      },
      {
        id:"37",
        photo:'https://i.ibb.co/4tDkWJL/316240475-1857381877937757-2742864709315182106-n.jpg',
        name: 'හෙනකදයා (සුළුවිෂ)',
        bodyColor: '16',
        style: '1',
        poison:'3',
      },
      {
        id:"38",
        photo:'https://i.ibb.co/ZMq2j9R/316679704-1857378234604788-7446386286817051370-n.jpg',
        name: 'දගර දන්ඩා (සුළුවිෂ)',
        bodyColor: '16',
        style: '2',
        poison:'3',
      },
      {
        id:"39",
        photo:'https://i.ibb.co/KV0Y0Dr/316805553-1857378281271450-7481738524778652466-n.jpg',
        name: 'පදුරැ හාල්දණ්ඩා (නිර්විෂ)',
        bodyColor: '11',
        style: '1',
        poison:'4',
      },
      {
        id:"40",
        photo:'https://i.ibb.co/v1024ZV/316821055-1857381947937750-341723614465308653-n.jpg',
        name: 'වික්‍රමසිංහලාගේ හාල්දණ්ඩා (නිර්විෂ)',
        bodyColor: '11',
        style: '6',
        poison:'4',
      },
      {
        id:"41",
        photo:'https://i.ibb.co/pxY4PpK/316543602-1857382241271054-549907175908013951-n.jpg',
        name: 'වයිරි හාල්දණ්ඩා (නිර්විෂ)',
        bodyColor: '11',
        style: '1',
        poison:'4',
      },
      {
        id:"42",
        photo:'https://i.ibb.co/7SmDBLf/317086902-1857382291271049-6104172733022101557-n.jpg',
        name: 'olivers haldanda',
        bodyColor: '11',
        style: '3',
        poison:'4',
      },
      {
        id:"43",
        photo:'https://i.ibb.co/TWsx9Sd/316282202-1857382347937710-5405095531960463606-n.jpg',
        name: 'මුකලන් හාල්දණ්ඩා (නිර්විෂ)',
        bodyColor: '14',
        style: '6',
        poison:'4',
      },
      {
        id:"44",
        photo:'https://i.ibb.co/CHcCCcg/316416488-1857378537938091-8089055551229738358-n.jpg',
        name: 'සිංහරාජ හාල්දණ්ඩා (නිර්විෂ)',
        bodyColor: '17',
        style: '8',
        poison:'4',
      },
      {
        id:"45",
        photo:'https://i.ibb.co/q0jP336/316535207-1857378577938087-7600397055188974336-n.jpg',
        name: 'තුරැ හාල්දණ්ඩා (නිර්විෂ)',
        bodyColor: '11',
        style: '3',
        poison:'4',
      },
      {
        id:"46",
        photo:'https://i.ibb.co/GJsk6r1/316952126-1857382381271040-645209735835219232-n.jpg',
        name: 'පදුරැ මාපිලා (සුළුවිෂ)',
        bodyColor: '11',
        style: '4',
        poison:'3',
      },
      {
        id:"47",
        photo:'https://i.ibb.co/KyzZVHw/316834603-1857382581271020-1782425243830669744-n.jpg',
        name: 'ගැට රදනකයා (නිර්විෂ)',
        bodyColor: '11',
        style: '8',
        poison:'4',
      },
      {
        id:"48",
        photo:'https://i.ibb.co/6XFyP2y/317085508-1857382621271016-624249766056992686-n.jpg',
        name: 'චිත්‍රසේකරගේ ගැට රදනකයා (නිර්විෂ)',
        bodyColor: '11',
        style: '8',
        poison:'4',
      },
      {
        id:"49",
        photo:'https://i.ibb.co/2ZPtPWk/316824159-1857379031271375-3584073671296802488-n.jpg',
        name: 'පන් බරියා (නිර්විෂ)',
        bodyColor: '18',
        style: '3',
        poison:'4',
      },
      {
        id:"50",
        photo:'https://i.ibb.co/SJg9Qfc/316826928-1857382711271007-7364646188542246931-n.jpg',
        name: 'මල් රදනකයා (නිර්විෂ)',
        bodyColor: '11',
        style: '1',
        poison:'4',
      },
      {
        id:"51",
        photo:'https://i.ibb.co/L8NfqXx/317079073-1857382807937664-5990697423413149807-n.jpg',
        name: 'දාර රදනකයා (නිර්විෂ)',
        bodyColor: '12',
        style: '8',
        poison:'4',
      },
      {
        id:"52",
        photo:'https://i.ibb.co/d6Tthhv/317497710-1857382844604327-838186173704194825-n.jpg',
        name: 'කබර රදනකයා (නිර්විෂ)',
        bodyColor: '11',
        style: '8',
        poison:'4',
      },
      {
        id:"53",
        photo:'https://i.ibb.co/8YYGGRC/316821979-1857382861270992-5170443146917453186-n.jpg',
        name: 'අරණි දත්කැටියා (නිර්විෂ)',
        bodyColor: '18',
        style: '1',
        poison:'4',
      },
      {
        id:"54",
        photo:'https://i.ibb.co/Bs3F7VD/317386484-1857382871270991-1927190618073382220-n.jpg',
        name: 'කබර දත්කැටියා (නිර්විෂ)',
        bodyColor: '11',
        style: '1',
        poison:'4',
      },
      {
        id:"55",
        photo:'https://i.ibb.co/cLyhy77/316272343-1857382924604319-3620384722505070474-n.jpg',
        name: 'ගැරඩියා (නිර්විෂ)',
        bodyColor: '18',
        style: '1',
        poison:'4',
      },
      {
        id:"56",
        photo:'https://i.ibb.co/8mMK701/316677690-1857383017937643-6650838675420462781-n.jpg',
        name: 'කුරැන් මැඩිල්ලා (නිර්විෂ)',
        bodyColor: '11',
        style: '4',
        poison:'4',
      },
      {
        id:"57",
        photo:'https://i.ibb.co/gD8PrfS/317090456-1857383237937621-754834199082624356-n.jpg',
        name: 'කලු මැඩිල්ලා (නිර්විෂ)',
        bodyColor: '11',
        style: '4',
        poison:'4',
      },
      {
        id:"58",
        photo:'https://i.ibb.co/ccx8n54/316298526-1857383284604283-931234347988911414-n.jpg',
        name: 'ඩී සිල්වාගේ මැඩිල්ලා (නිර්විෂ)',
        bodyColor: '15',
        style: '4',
        poison:'4',
      },
      {
        id:"59",
        photo:'https://i.ibb.co/WGV96dZ/316664363-1857383371270941-213079847817433559-n.jpg',
        name: 'කෙටිවල් මැඩිල්ලා (නිර්විෂ)',
        bodyColor: '11',
        style: '3',
        poison:'4',
      },
      {
        id:"60",
        photo:'https://i.ibb.co/x8v6zgK/317079497-1857379817937963-6348897381204670212-n.jpg',
        name: 'කුඩා මැඩිල්ලා (නිර්විෂ)',
        bodyColor: '17',
        style: '3',
        poison:'4',
      },
      {
        id:"61",
        photo:'https://i.ibb.co/Hg4yNyF/316947961-1857379851271293-1903098865929583815-n.jpg',
        name: 'රාවණාගේ මැඩිල්ලා (නිර්විෂ)',
        bodyColor: '12',
        style: '3',
        poison:'4',
      },
      {
        id:"62",
        photo:'https://i.ibb.co/M9LSQZx/316414925-1857379964604615-6644273645912604907-n.jpg',
        name: 'ලංකා දියබරියා (නිර්විෂ)',
        bodyColor: '1',
        style: '1',
        poison:'4',
      },
      {
        id:"63",
        photo:'https://i.ibb.co/h8NjhKp/316675768-1857380037937941-638417011954400800-n.jpg',
        name: 'මල් කරවලා (සුළුවිෂ)',
        bodyColor: '12',
        style: '6',
        poison:'3',
      },
      {
        id:"64",
        photo:'https://i.ibb.co/c1NqtCF/316685914-1857380094604602-2806353174796927980-n.jpg',
        name: 'පලා බරියා (නිර්විෂ)',
        bodyColor: '13',
        style: '3',
        poison:'4',
      },
      {
        id:"65",
        photo:'https://i.ibb.co/KxT1tRt/316950639-1857383497937595-428415771492184780-n.jpg',
        name: 'දැති ගෝමරයා (නිර්විෂ)',
        bodyColor: '17',
        style: '4',
        poison:'4',
      },
      {
        id:"66",
        photo:'https://i.ibb.co/5B3ZrWD/317558714-1857380174604594-9170390152203010097-n.jpg',
        name: 'තෙල් කරවලා (උග්‍රවිෂ)',
        bodyColor: '12',
        style: '7',
        poison:'1',
      },
      {
        id:"67",
        photo:'https://i.ibb.co/Zz696Ws/316671520-1857380314604580-3439727326173227905-n.jpg',
        name: 'බඩ රතු දෙපත් කලුවා (සුළුවිෂ)',
        bodyColor: '15',
        style: '4',
        poison:'3',
      },
      {
        id:"68",
        photo:'https://i.ibb.co/wdpzBmZ/316961252-1857383571270921-6792451125794637638-n.jpg',
        name: 'දෙපත් කලුවා (සුළුවිෂ)',
        bodyColor: '11',
        style: '3',
        poison:'3',
      },
      {
        id:"69",
        photo:'https://i.ibb.co/pvTCQt4/317306642-1857380407937904-3049398055683799024-n.jpg',
        name: 'නයා (උග්‍රවිෂ)',
        bodyColor: '12',
        style: '1',
        poison:'1',
      },
      {
        id:"70",
        photo:'https://i.ibb.co/HPSZ6mr/316954992-1857380454604566-5307248538529954813-n.jpg',
        name: 'මහ වාලක්කඩියා (උග්‍රවිෂ)',
        bodyColor: '13',
        style: '8',
        poison:'1',
      },
      {
        id:"71",
        photo:'https://i.ibb.co/n8MhGkF/317077755-1857383934604218-8769922894679344015-n.jpg',
        name: 'කුණුදිය කලුවා (සුළුවිෂ)',
        bodyColor: '11',
        style: '1',
        poison:'3',
      },
      {
        id:"72",
        photo:'https://i.ibb.co/Z8jL8T0/316804167-1857384214604190-3458474546780414508-n.jpg',
        name: 'දේදුණු බරියා (සුළුවිෂ)',
        bodyColor: '12',
        style: '3',
        poison:'3',
      },
      {
        id:"73",
        photo:'https://i.ibb.co/D9hNyhX/316682753-1857384284604183-3114621960025945856-n.jpg',
        name: 'ප්‍රෙවොස්ටිගේ දියබරියා (සුළුවිෂ)',
        bodyColor: '12',
        style: '3',
        poison:'3',
      },
      {
        id:"74",
        photo:'https://i.ibb.co/J2cgbDy/317098583-1857384354604176-512275243889626729-n.jpg',
        name: 'පහතරට මුකලන් තෙලිස්සා (උග්‍රවිෂ)',
        bodyColor: '11',
        style: '4',
        poison:'1',
      },
      {
        id:"75",
        photo:'https://i.ibb.co/L1Sqq6z/316680365-1857384384604173-4740804284346373495-n.jpg',
        name: 'කදුකර මුකලන් තෙලිස්සා',
        bodyColor: '12',
        style: '4',
        poison:'2',
      },
      {
        id:"76",
        photo:'https://i.ibb.co/bg5rbrg/316304244-1857381477937797-3930290835420174475-n.jpg',
        name: 'තිත් පොළගා (උග්‍රවිෂ)',
        bodyColor: '11',
        style: '5',
        poison:'1',
      },
      {
        id:"77",
        photo:'https://i.ibb.co/nsPW1fL/316279560-1857384487937496-5925801472602809690-n.jpg',
        name: 'වැලි පොළගා (උග්‍රවිෂ)',
        bodyColor: '11',
        style: '5',
        poison:'1',
      },



  ];

  export default snakedata;